import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { IS_PSUEDO_NAME_SYSTEM_GENERATED } from "../redux/constants/Auth";

function SetUsernameRoute() {
  const isUsernameTrue =
    localStorage.getItem(IS_PSUEDO_NAME_SYSTEM_GENERATED) === "true"
      ? true
      : false;
  return isUsernameTrue ? <Outlet /> : <Navigate to="/landing-page" />;
}

export default SetUsernameRoute;
